import { handleAvailable, handleUnavailable } from '../reducerHandlers';
import {
  GET_SOURCES_FAILURE,
  GET_SOURCES_REQUEST,
  GET_SOURCES_SUCCESS,
  SNACK_ALERT_SET,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
  loading: false,
  sources: [],
  requestId: null,
};

// Reducer

export const reducer = createReducer(defaultState, {
  [GET_SOURCES_REQUEST]: handleSourcesRequest,
  [GET_SOURCES_SUCCESS]: handleAvailable,
  [GET_SOURCES_FAILURE]: handleUnavailable,
});

function handleSourcesRequest(state, { payload: { requestId } }) {
  return { ...state, loading: true, requestId };
}

// Actions

export function getSources(session, objectType) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    // Both session and objectType are required; skip if either is not yet selected
    if (!session || !objectType) return;
    const requestId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    dispatch({ type: GET_SOURCES_REQUEST, payload: { requestId } });
    try {
      const response = await dataSource.getSources(session, objectType);
      if (getState().sources.requestId !== requestId) return;
      const sources = Array.isArray(response?.sources) ? response.sources : [];
      dispatch({
        type: GET_SOURCES_SUCCESS,
        payload: { keyState: 'sources', data: sources, loadingName: 'loading' },
      });
    } catch (error) {
      if (getState().sources.requestId !== requestId) return;
      dispatch({
        type: GET_SOURCES_FAILURE,
        payload: { keyState: 'sources', loadingName: 'loading', defaultState: [] },
      });
      const snack = {
        open: true,
        message: 'There was an error getting the sources: ' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_ALERT_SET, payload: { snack } });
    }
  };
}
